(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-delay-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.querySelector('[data-shipping-delay-popup]');

    if (!popup || typeof popup.showModal !== 'function') return;

    const closeButton = popup.querySelector('[data-shipping-delay-popup-close]');
    const sessionStartedKey = 'shipping-delay-popup-session-started';
    const shownKey = 'shipping-delay-popup-shown';
    const delay = 20000;

    const getSessionValue = (key) => {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const setSessionValue = (key, value) => {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {
        return;
      }
    };

    if (getSessionValue(shownKey)) return;

    const storedStart = Number(getSessionValue(sessionStartedKey));
    const sessionStarted = Number.isFinite(storedStart) && storedStart > 0 ? storedStart : Date.now();
    const remainingDelay = Math.max(0, delay - (Date.now() - sessionStarted));

    if (!storedStart) setSessionValue(sessionStartedKey, String(sessionStarted));

    const closePopup = () => {
      popup.classList.remove('shipping-delay-popup--visible');
      window.setTimeout(() => {
        if (popup.open) popup.close();
      }, 320);
    };

    const showPopup = () => {
      if (popup.open || getSessionValue(shownKey)) return;

      popup.showModal();
      setSessionValue(shownKey, 'true');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => popup.classList.add('shipping-delay-popup--visible'));
      });
    };

    window.setTimeout(showPopup, remainingDelay);

    closeButton?.addEventListener('click', closePopup);
    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });
    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
